export default {
    oma: {
        //land suitability
        landSuitibility: "Geschiktheid van land",
        landSuitibilityReport: "Land Geschiktheidsrapport",
        generateNewReport: "Genereer nieuw rapport",
        operatorName: "Operator Naam",
        issueDate: "Uitgiftedatum",
        chooseYourLocation: "Kies uw locatie",
        getLandEvaluation: "Krijg landevaluatie",
        downloadPdfReport: "Download PDF-rapport",
        pleaseEnterCoordinateText:
          "Voer alstublieft de coördinaten (lengte- en breedtegraad) van de boerderijlocatie in om de score te zien.",
        noRecordAvailable: "Geen resultaten beschikbaar.",
        overallScoreForLand: "Algemene score voor landgeschiktheid",
        landEvaluation: "Landevaluatie",
        unsuitable: "Ongeschikt",
        marginally: "Marginaal",
        suitable: "Geschikt",
        moderately: "Matig",
        highly: "Zeer",
        back: "Terug",
        search: "Zoeken",
        showResults: "Resultaten weergeven",
    
        //weather analysis
        weatherAnalysisReport: "Weeranalyserapporten",
        weatherAnalysis: "Weeranalyse",
        getWeatherAnalysis: "Krijg weeranalyse",
        weatherReport: "Weerrapport",
        filterByDate: "Filteren op datum",
        insertCoordinateText:
          "Voer de coördinaten van de boerderij (of boom) locatie hierboven in, of gebruik de kaart hieronder om de boerderij (of boom) locatie aan te geven.",
        addTreeGeolocation: "Boomgeolocatie toevoegen",
        editTreeGeolocation: "Boomgeolocatie bewerken",
        plantationDate: "Datum geplant",
        notes: "Notities",
        uploadTreeImages: "Boomafbeeldingen uploaden",
    
        valueAtTheCoordinatesOfInterest: "Waarde op de Coördinaat van Belang",
        "Slope (%)": "Helling (%)",
        "Soil texture (USDA class)": "Bodemtextuur (USDA-klasse)",
        "Coarse fragments (vol%)": "Grove fragmenten (vol%)",
        Land: "Land",
        "Artificial surfaces (type)": "Kunstmatige oppervlakken (type)",
        "Proximity to Type 1 and 2 Roads (meters)":
          "Nabijheid van Type 1 en 2 Wegen (meters)",
        "Soil Chemical Properties": "Chemische eigenschappen van de bodem",
        "Soil Physical Properties": "Fysische eigenschappen van de bodem",
        "Soil organic carbon (%)": "Organische koolstof in de bodem (%)",
        "Soil pH": "Bodem-pH",
        "Soil salinity (ECe))": "Bodemzoutgehalte (ECe)",
        "Mean annual temperature (°C)": "Gemiddelde jaarlijkse temperatuur (°C)",
        Weather: "Weer",
        "Mean minimum temperature of coldest month (°C)":
          "Gemiddelde minimumtemperatuur van de koudste maand (°C)",
        "Mean annual precipitation (mm)": "Gemiddelde jaarlijkse neerslag (mm)",
        OrDragDrop: "of sleep en zet hier neer",
        "Mean annual relative humidity (%)": "Gemiddelde jaarlijkse relatieve vochtigheid (%)",
        downloadCSVFormat: "Downloaden als CSV-indeling",
        downloadXLSFormat: "Downloaden als XLS-indeling",
        downloadGeoJsonFormat: "Downloaden als GeoJSON-indeling",
        downloadXMLFormat: "Downloaden als XML-indeling",
        downloadTopoJSONFormat: "Downloaden als TopoJSON-indeling",
        downloadGeobufFormat: "Downloaden als Geobuf-indeling",
        downloadGeoPackageFormat: "Downloaden als GeoPackage-indeling",
        downloadFileFormatTemplates: "Downloaden van bestandsindelingssjablonen",
    
        status: "Status",
        actions: "Acties",
        action: "Actie",
        download: "Download",
        removeFile: "Bestand verwijderen",
        import : "Importeren",
        history: "Geschiedenis",
      },
}